import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function BonusGridSection() {
  const bonuses = [{
    id: 1,
    title: 'The Ultimate Picky Eater Solution',
    desc: 'The end of mealtime battles. Psychological strategies and "hidden veggie" recipes to get picky kids to try new foods without the fight.',
    value: '$47',
    color: 'bg-orange-100',
    textColor: 'text-orange-900',
    image: 'https://cdn.magicpatterns.com/uploads/7wKkVLX7BW9Hvr4LjxTzcF/767ec8a2-4037-4095-b932-daa41bcd1f1e-mockup.webp'
  }, {
    id: 2,
    title: '100 No-Bake Lunchbox Snacks',
    desc: 'Zero cooking required. Healthy bars, energy bites, and snacks you can whip up in 5 minutes without even turning on the oven.',
    value: '$37',
    color: 'bg-blue-100',
    textColor: 'text-blue-900',
    image: 'https://cdn.magicpatterns.com/uploads/4LXmgdSSAwFcdqbkNfv2E5/80136b58-f8d2-4159-be59-d712c849c59a-mockup.webp'
  }, {
    id: 3,
    title: 'The 30-Day Happy Lunchbox Challenge',
    desc: "New habits, zero stress. A day-by-day roadmap to transform your child's eating habits in just one month.",
    value: '$27',
    color: 'bg-pink-100',
    textColor: 'text-pink-900',
    image: 'https://cdn.magicpatterns.com/uploads/3eSdvRqvco4J1evKmWy4rX/477a8d2b-9a55-424b-9e98-e5df40f86ce3-mockup.webp'
  }, {
    id: 4,
    title: 'Healthy Treats & Desserts Kids Love',
    desc: 'Guilt-free sweetness. Swap processed candy for natural desserts made with real fruit and wholesome ingredients.',
    value: '$37',
    color: 'bg-purple-100',
    textColor: 'text-purple-900',
    image: 'https://cdn.magicpatterns.com/uploads/cfikDwBknepu3dhgeh1xTB/b612c79c-fb9b-49a0-8d07-b01f82d2ccb0-mockup.webp'
  }, {
    id: 5,
    title: "The Busy Mom's 15-Min Meal Prep System",
    desc: 'Master your kitchen. My secret batch-cooking system to prep the entire week of lunches in one short Sunday session.',
    value: '$47',
    color: 'bg-teal-100',
    textColor: 'text-teal-900',
    image: 'https://cdn.magicpatterns.com/uploads/5Kb4yy7J61MYKidNLEknkE/13597411-ae23-4a71-ad37-23203bf6ef20-mockup.webp'
  }];
  return <section className="bg-[#1f2e10] py-16 px-4" data-id="element-27">
      <div className="max-w-6xl mx-auto" data-id="element-28">
        <div className="text-center mb-12" data-id="element-29">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white uppercase" data-id="element-30">
            Plus, you're getting these <br data-id="element-31" />
            <span className="text-[#c4f000]" data-id="element-32">
              5 exclusive bonuses (FREE TODAY):
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-5xl mx-auto" data-id="element-33">
          {bonuses.map((bonus, idx) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className={`bg-white rounded-2xl overflow-hidden shadow-xl flex flex-col sm:flex-row ${idx === 4 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-34">
              <div className={`w-full sm:w-2/5 ${bonus.color} p-4 flex items-center justify-center relative min-h-[200px]`} data-id="element-35">
                <div className="absolute top-2 left-2 bg-red-500 text-white text-xs font-bold px-2 py-1 rounded-full transform -rotate-12" data-id="element-36">
                  BONUS #{bonus.id}
                </div>
                <div className="absolute top-2 right-2 bg-[#c4f000] text-[#1f2e10] text-xs font-bold px-2 py-1 rounded-full" data-id="element-37">
                  VALUE {bonus.value}
                </div>
                {/* Book Cover */}
                <img src={bonus.image} alt={bonus.title} className="w-3/4 aspect-[3/4] object-cover rounded-lg shadow-md" loading="lazy" decoding="async" data-id="element-38" />
              </div>
              <div className="w-full sm:w-3/5 p-6 flex flex-col justify-center" data-id="element-39">
                <span className="text-xs font-bold text-gray-400 uppercase tracking-wider mb-1" data-id="element-40">
                  Exclusive Bonus
                </span>
                <h3 className="font-bold text-xl text-[#1f2e10] mb-3 leading-tight" data-id="element-41">
                  {bonus.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed" data-id="element-42">
                  {bonus.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}